import React from 'react';

const Pagination = ({ itemsPerPage, totalItems, currentPage, paginate }) => {
  const pageNumbers = [];
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Calculate start and end page numbers to display
  let startPage = Math.max(1, currentPage - 5);
  let endPage = Math.min(totalPages, startPage + 9);

  // Adjust start and end page numbers if at the beginning or end of the page list
  if (startPage === 1) {
    endPage = Math.min(totalPages, 10);
  } else if (endPage === totalPages) {
    startPage = Math.max(1, totalPages - 9);
  }

  // Check if the first page number is included and add it if not
  if (!pageNumbers.includes(1) && totalPages > 1 && currentPage > 10) {
    pageNumbers.push(1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  // Check if the last page number is included and add it if not
  if (!pageNumbers.includes(totalPages) && totalPages > 1) {
    pageNumbers.push(totalPages);
  }

  return (
    <nav className="flex items-center justify-center mt-4">
      <ul className="pagination flex space-x-2">
        {currentPage > 1 && (
          <li>
            <button
              onClick={() => paginate(currentPage - 1)}
              className="px-3 py-1 rounded-md bg-blue-500 text-white hover:bg-blue-600 focus:outline-none"
            >
              &lt;
            </button>
          </li>
        )}
        {pageNumbers.map((number, index) => (
          <li key={index}>
            <button
              onClick={() => paginate(number)}
              className={`px-3 py-1 rounded-md ${
                currentPage === number ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800 hover:bg-blue-500 hover:text-white'
              } focus:outline-none`}
            >
              {number === '...' ? number : currentPage > 10 && number === 1 ? '1...' : number}
            </button>
          </li>
        ))}
        {currentPage < totalPages && (
          <li>
            <button
              onClick={() => paginate(currentPage + 1)}
              className="px-3 py-1 rounded-md bg-blue-500 text-white hover:bg-blue-600 focus:outline-none"
            >
              &gt;
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Pagination;
